/**
 * MSAL Configuration for Microsoft Entra ID (Multi-tenant)
 * Based on constitution v1.1.0: Least Privilege & Incremental Consent
 */

import { PublicClientApplication, Configuration } from '@azure/msal-browser'

// TODO: Replace with your actual Azure AD app registration details
const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_CLIENT_ID || 'YOUR_CLIENT_ID',
        authority: 'https://login.microsoftonline.com/common', // Multi-tenant
        redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}

export const msalInstance = new PublicClientApplication(msalConfig)

// Initialize MSAL instance
let msalInitialized = false;
export const initializeMsal = async () => {
    if (!msalInitialized) {
        await msalInstance.initialize();
        msalInitialized = true;
    }
};

// Base login request - only OIDC/identity scopes (NOT resource/API scopes)
// Graph API scopes (Sites.*, etc.) are requested separately via graphApiRequest in authService.ts
export const loginRequest = {
    scopes: ['User.Read', 'offline_access', 'openid', 'profile'],
}

// Licensing API token request - for Injio NG Licensing Functions
// The API expects audience: api://d574b8a7-9ae5-4a61-bde4-e2e3c92a6ebd
// Using specific scope (access_as_user) for pre-authorization support
export const licensingApiRequest = {
    scopes: [
        import.meta.env.VITE_LICENSING_API_SCOPE || 'api://1b562f03-afee-4010-9e76-d6291e2240e4/access_as_user'
    ],
}
